import { SolarType } from '../CommonTypes';
import useSolars from '../hooks/useSolars';
import { showSolarOptionsAtom } from '../states/planner';
import { useAtom } from 'jotai';

export const SolarButton = ({ currentSolar }: { currentSolar: SolarType | null }) => {
  const [showSolarOptions, setShowSolarOptions] = useAtom(showSolarOptionsAtom);

  const [solars] = useSolars(currentSolar?.viewid);

  if (!solars || solars.length == 0) return null;
  if (process.env.NODE_ENV !== 'development') return null;

  return (
    <div className="z-2 absolute right-2 top-2 text-white md:top-2">
      <button
        data-tooltip-id="solar-tooltip"
        onClick={() => setShowSolarOptions(!showSolarOptions)}
        className={`rounded bg-black/60 px-3 py-1 text-sm text-white sm:hover:scale-105 ${!showSolarOptions ? 'visible' : 'invisible'}`}
      >
        {currentSolar?.date} <span className="ml-5">{currentSolar?.time}</span>
      </button>
    </div>
  );
};
